import React from "react";

const Dashboard = React.lazy(() => import("../views/dashboard"));

const Events = React.lazy(() => import("../views/Booking/Events"));
const Assistants = React.lazy(() => import("../views/Booking/Assistants"));

const routes = [
  { path: "/", exact: true, name: "Inicio" },
  { path: "/inicio", name: "Inicio", component: Dashboard },
  { path: "/reserva", name: "Reservas", component: Events, exact: true },
  { path: "/reserva/servicios", name: "Servicios", component: Events },
  { path: "/reserva/asistentes", name: "Asistentes", component: Assistants },
];

export default routes;
